import { DoBootstrap, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';
import { CfShellLibModule, CustomRouteReuseStrategy } from '@cplace-next/cf-shell-lib';
import { cf_window, NgswService, NgswManifest, UtilsModule } from '@cplace-next/cf-frontend-sdk';
import 'hammerjs';

import manifest from '../manifest.json';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';

const win = window as cf_window;
const baseHref = win._cf_fe20_config_.baseHrefOverride || `${win._cf_fe20_config_.localDeployUrl}${manifest.name}/`;

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CfShellLibModule,
    RouterModule.forRoot([
      {
        path: '**',
        component: AppComponent,
      },
    ]),
    // ServiceWorkerModule.register(baseHref.concat('ngsw-worker.js'), {
    //   enabled: environment.production,
    //   // Register the ServiceWorker as soon as the app is stable
    //   // or after 30 seconds (whichever comes first).
    //   registrationStrategy: 'registerWhenStable:30000',
    // }),
    UtilsModule,
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: baseHref,
    },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
  ],
})
export class AppModule implements DoBootstrap {
  private readonly cdnHost: string = environment.cdnHost;
  private readonly defaultApp = environment.defaultApp;
  private deployUrl: string;
  private scriptsLoadedEvent = new Event('CF_FE_SCRIPTS_LOADED');

  constructor(private ngswService: NgswService) {
    const feConfig = win._cf_fe20_config_;
    this.deployUrl = '';
    if (feConfig.useCDN) {
      this.deployUrl = `${this.cdnHost}/${feConfig.localDeployUrl}${this.defaultApp}/${win._cf_fe20_config_.apps[this.defaultApp]}`;
    } else {
      this.deployUrl = `${feConfig.localDeployUrl}${this.defaultApp}`;
    }
    this.init();
  }
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  public ngDoBootstrap() {
    // needed to boot app with no starting cmp
  }

  private init() {
    this.ngswService.getManifest(this.deployUrl).then((res) => {
      this.handleCssInsertionMarker(res);
    });
  }

  private handleCssInsertionMarker(manifest: NgswManifest): void {
    const head: HTMLHeadElement | null = win.document.querySelector('head');
    const cssInsertionMarker: HTMLLinkElement | null = win.document.querySelector('link#css-insertion-marker');
    if (head) {
      const assets = (manifest.assetGroups || [])[0];
      if (assets) {
        const found: string | undefined = assets.urls.find((i: string) => i === '/styles.css');
        if (found) {
          const styleEl = Array.from(head.children).find((elem: Element) => {
            const attr = elem.attributes.getNamedItem('href');
            return attr && attr.value === this.deployUrl.concat(found);
          }) as any;
          if (cssInsertionMarker) {
            head.insertBefore(styleEl, cssInsertionMarker);
          } else {
            head.appendChild(styleEl);
          }
        }
      }
    }
    document.dispatchEvent(this.scriptsLoadedEvent);
  }
}
